import { createStyles, Theme } from '@material-ui/core'

export default (theme: Theme) =>
  createStyles({
    actionContainer: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(2),
    },
  })
